import {
	getMipProgrammeEntities,
	MipProgrammeEntity,
} from '@dealstack/frontend/shared/dataExchange/services/mip.service';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

export const MIP_PROGRAMME_ENTITIES_QUERY_KEY = 'mip-programme-entities';

export const useMipProgrammeEntities = (
	programmeId?: string
): UseQueryResult<MipProgrammeEntity[]> =>
	useQuery({
		queryKey: [MIP_PROGRAMME_ENTITIES_QUERY_KEY, programmeId],
		queryFn: getMipProgrammeEntities,
		enabled: !!programmeId,
	});
